import React from "react";
import { round } from "lodash";

import NutrientInput from "../../../../parts/inputs/nutrient-input";

const KcalInputs = ({
  calories,
  proteins = 0,
  carbs = 0,
  fats = 0,
  proteinsPercent = 0,
  carbsPercent = 0,
  fatsPercent = 0,
  fibers = 0,
  handleChange,
  isRestDay = false,
}) => {
  const onCaloriesChange = (e) => {
    const { name, value } = e.target;

    const updates = { [name]: value };

    if (Number(value)) {
      if (!isRestDay) {
        updates.proteins = round((value * (proteinsPercent / 100)) / 4, 1);
        updates.carbs = round((value * (carbsPercent / 100)) / 4, 1);
        updates.fats = round((value * (fatsPercent / 100)) / 9, 1);
      } else {
        updates.restDayProteins = round(
          (value * (proteinsPercent / 100)) / 4,
          1
        );
        updates.restDayCarbs = round((value * (carbsPercent / 100)) / 4, 1);
        updates.restDayFats = round((value * (fatsPercent / 100)) / 9, 1);
      }
    }

    handleChange(e, updates);
  };

  const onNutrientChange = (e) => {
    const { name, value } = e.target;

    const updates = { [name]: value };

    const percentField = name + "Percent";
    const kcalMultiplier = name === "fats" || name === "restDayFats" ? 9 : 4;

    if (calories && Number(value)) {
      updates[percentField] = round(
        ((value * kcalMultiplier) / calories) * 100,
        1
      );
    }

    handleChange(e, updates);
  };

  const onPercentChange = (e) => {
    const { name, value } = e.target;

    const updates = { [name]: value };

    const nutrientField = name.split("Percent")[0];
    const kcalMultiplier =
      nutrientField === "fats" || nutrientField === "restDayFats" ? 9 : 4;

    if (calories && Number(value)) {
      updates[nutrientField] = round(
        (calories * (value / 100)) / kcalMultiplier,
        1
      );
    }

    handleChange(e, updates);
  };

  const pfcPercent = round(
    Number(proteinsPercent || 0) +
      Number(carbsPercent || 0) +
      Number(fatsPercent || 0),
    1
  );

  const pfcDelta = round(pfcPercent - 100, 1);

  let remainingKcal = 0;

  if (calories) {
    const targetKCal = Number(calories || 0);
    const allocatedKcal = round(
      Number(proteins || 0) * 4 +
        Number(carbs || 0) * 4 +
        Number(fats || 0) * 9,
      1
    );

    remainingKcal = round(targetKCal - allocatedKcal, 1);
  }

  const readOnly = !Boolean(calories);

  return [
    <div className="form-col">
      <div className="form-col">
        <label className="label req" htmlFor="calories">
          kCal Target
        </label>
        <NutrientInput
          name={isRestDay ? "restDayCalories" : "calories"}
          value={calories}
          onChange={onCaloriesChange}
        />
      </div>
    </div>,

    <div className="form-col">
      <div className="form-col">
        <label className="label proteins req" htmlFor="proteins">
          Protein (1g = 4kCal)
        </label>
        <div className="input-row">
          <NutrientInput
            name={isRestDay ? "restDayProteins" : "proteins"}
            suffix="g"
            value={proteins}
            onChange={onNutrientChange}
            readOnly={readOnly}
          />
          <NutrientInput
            name={isRestDay ? "restDayProteinsPercent" : "proteinsPercent"}
            suffix="%"
            percent
            value={proteinsPercent}
            onChange={onPercentChange}
            readOnly={readOnly}
          />
        </div>
      </div>

      <div className="form-col">
        <label className="label carbs req" htmlFor="carbs">
          Carbs (1g = 4kCal)
        </label>
        <div className="input-row">
          <NutrientInput
            name={isRestDay ? "restDayCarbs" : "carbs"}
            suffix="g"
            value={carbs}
            onChange={onNutrientChange}
            readOnly={readOnly}
          />
          <NutrientInput
            name={isRestDay ? "restDayCarbsPercent" : "carbsPercent"}
            suffix="%"
            percent
            value={carbsPercent}
            onChange={onPercentChange}
            readOnly={readOnly}
          />
        </div>
      </div>
    </div>,

    <div className="form-col">
      <div className="form-col">
        <label className="label fats req" htmlFor="fats">
          Fat (1g = 9kCal)
        </label>
        <div className="input-row">
          <NutrientInput
            name={isRestDay ? "restDayFats" : "fats"}
            suffix="g"
            value={fats}
            onChange={onNutrientChange}
            readOnly={readOnly}
          />
          <NutrientInput
            name={isRestDay ? "restDayFatsPercent" : "fatsPercent"}
            suffix="%"
            percent
            value={fatsPercent}
            onChange={onPercentChange}
            readOnly={readOnly}
          />
        </div>
      </div>

      <div className="form-col">
        <label className="label fibers" htmlFor="fibers">
          Fiber (Optional)
        </label>
        <NutrientInput
          name={isRestDay ? "restDayFibers" : "fibers"}
          value={fibers}
          suffix="g"
          onChange={handleChange}
        />
      </div>
    </div>,

    <div className="mt-4 flex gap-2">
      {pfcDelta !== 0 && <p>Remaining kCal to allocate = {remainingKcal}</p>}
      <p className="chip info">
        PFC% = {pfcPercent}%
        {pfcDelta !== 0 && (
          <span className="pfc-delta">
            {" "}
            ({pfcDelta > 0 ? "+" : ""}
            {pfcDelta}%)
          </span>
        )}
      </p>
      <p className="chip info">Must equal 100%</p>
    </div>,
  ];
};

export default KcalInputs;
